import Vue from 'vue'
import App from './app.vue'
import router, {resetRouter} from './router'
import axios from './utils/myaxios'
Vue.prototype.$ajax =axios
axios.defaults.withCredentials=true
import swal from 'sweetalert'
Vue.prototype.$swal=swal

Vue.prototype.$modelUrl="http://"+location.host+"/download/model";


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
    Options: {
        'inline': true,
        'button': true,
        'navbar': true,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    } })

import './static/element-ui/index';
import 'element-ui/lib/theme-chalk/index.css'
import elment from "element-ui"
import barTitle from "./components/title"
//import notify from "./static/js/notify"
Vue.use(elment)
Vue.component('barTitle',barTitle)
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import upload from './utils/upload'
Vue.prototype.$upload=upload

import tools from './utils/tools'
Vue.prototype.$tools=tools

import check from './static/js/check'
Vue.prototype.$check=check



import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import store from './vuex/store'
Vue.use(store)

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

Vue.config.productionTip = false

import qrcode from './static/js/qrcode'
Vue.prototype.$qrcode=qrcode


import listenHeight from "./static/js/listenHeight"
Vue.prototype.$listenHeight=listenHeight

import {aesEncrypt,aesDecrypt} from './utils/mycrypto'

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)


/**
 * 路由拦截器
 */
router.beforeEach((to,from,next)=>{

    let loginUser = sessionStorage.getItem("loginUser")
    Vue.prototype.$loginUser = loginUser===null?{}:JSON.parse(loginUser)

    if(to.fullPath==="/agentLogin"){
        next("/")
    }

    if(to.matched.some(function (item) {
        resetRouter()
        return item.meta.loginRequire
    })) {
        if (to.path.startsWith("/web") || to.path.startsWith("/wechat")) {
            //公众号拦截
            let webToken =localStorage.getItem("web-token")
            if(webToken==null){
                if(to.path.startsWith("/wechat")){
                    next()
                }else{
                    next("/wechat")
                }
            }else{
                next()
            }
        } else {
            //sys拦截
            if(to.path.startsWith("/account")){
                let sysToken = sessionStorage.getItem("sys-token");
                if (sysToken==null) {
                    if(to.path==="/account"){
                        next()
                    }else{
                        next("/account")
                    }
                } else {
                    next();
                }
            }else if(to.path.startsWith("/agentlogin")){
                let agentToken = sessionStorage.getItem("agent-token");
                if(agentToken==null){
                    if(to.path==="/agentlogin"){
                        next()
                    }else {
                        next("/agentlogin")
                    }
                }else {
                    next()
                }
            }else{
                next()
            }

        }

    }else{
        next()
    }
    next()

});





new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
